import type { ReactNode } from "react";

/**
 * One preference in the Preferences dialog: a heading naming it, an optional
 * sentence on what it changes, and its control. Same frame as the settings
 * cards on the admin pages, so a preference reads like a setting.
 */
export function PreferenceCard({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-4 rounded-xl border border-border bg-card p-5">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {children}
    </section>
  );
}
